import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { GlobalContext } from "../../../App";

const admin = [
    {
        id: 1,
        url: "/category",
        label: "Blogs Category",
        img1: "/assets/images/category.svg",
        alt1: "Category Icon",
        className1: "category-icon",
    },
    {
        id: 2,
        url: "/blog",
        label: "Blogs",
        img1: "/assets/images/blog.svg",
        alt1: "Blog Icon",
        className1: "blog-icon",
    },
];

const SidebarMenu = () => {
    const imageUrl = "/assets/images/";
    const { settoggleBtn, toggleBtn } = useContext(GlobalContext);
    return (
        <div className={`sidebar  ${toggleBtn === true ? "sidebar-toggle" : ""}`}>
            <div className="logo">
                <img src={imageUrl + "logo.svg"} alt="" className="w-[150px] m-auto" />
            </div>
            <ul className="p-0 mt-20">
                {/* Admin section start */}
                {admin?.map((data, index) => {
                    // --------------- data Destructuring
                    const { id, url, label, className1, img1, alt1, disabled } = data;
                    return (
                        <li key={id} className={`navActive`}>
                            <NavLink
                                to={url}
                                key={`sidebar-${index}`}
                                className={` ${disabled}`}
                                onClick={() => {
                                    settoggleBtn(false);
                                }}
                            >
                                <img src={img1} alt={alt1} className={className1} width={"18px"} />
                                {label}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
export default SidebarMenu;
